// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'branch';

export const Component = () => (
  <path
    fill='currentColor'
    d='M7.745 2.012A2.503 2.503 0 0 1 10 4.5l-.013.247A2.5 2.5 0 0 1 8 6.948v7.815a3.35 3.35 0 0 1 2.35-.963h2.85l.162-.004a3.3 3.3 0 0 0 3.107-2.856A2.498 2.498 0 0 1 17 6l.247.013A2.5 2.5 0 0 1 19.5 8.5l-.013.247a2.5 2.5 0 0 1-2.012 2.206 4.297 4.297 0 0 1-1.235 2.588 4.3 4.3 0 0 1-2.829 1.254l-.21.005H10.35A2.35 2.35 0 0 0 8 17.15v.9a2.507 2.507 0 0 1 1.268.682A2.5 2.5 0 0 1 10 20.5l-.013.247a2.5 2.5 0 0 1-4.974 0L5 20.5a2.501 2.501 0 0 1 2-2.45V6.949a2.5 2.5 0 0 1-1.987-2.2L5 4.5A2.502 2.502 0 0 1 7.5 2zM7.5 19A1.5 1.5 0 0 0 6 20.5l.008.148A1.5 1.5 0 0 0 9 20.5l-.007-.148A1.501 1.501 0 0 0 7.5 19zM17 7a1.5 1.5 0 1 0 1.5 1.5l-.008-.148a1.5 1.5 0 0 0-1.344-1.344zM7.5 3A1.501 1.501 0 0 0 6 4.5l.008.148A1.5 1.5 0 0 0 9 4.5l-.007-.147a1.502 1.502 0 0 0-1.346-1.346z'
  />
);

export const viewBox = '0 0 25 25';
